/* ==========================================================================
   Front Slider Gradient
   ========================================================================== */

// ...

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

function fadeGradient() {
  gsap.registerPlugin(ScrollTrigger);
  gsap.config({ nullTargetWarn: false });
  ScrollTrigger.create({
    trigger: ".headline-slider",
    start: "top 80%",
    end: "bottom bottom",
    scrub: true,
    toggleClass: { className: "fade-out", targets: ".bg-ani-slider" },
  });
}

window.addEventListener("load", function () {
  fadeGradient();
});
